<div class="wrapperDiv">
    <div class="col-md-6 col-10 login-form">
      <form name="form" (ngSubmit)="f.form.valid && login()" #f="ngForm" >
      <div class="avatar" style="text-align: center;">
        <i class="fa fa-4x fa-user-circle" aria-hidden="true"></i>
      </div>
          <div class="form-group titre center" >Login</div>
          <div class="form-group titre">
            <input
            class="form-control text"
            [ngClass] = "{ 'forminput-invalid':f.submitted &&
            (!model.username ||model.username?.length == 0
            ||!username.valid )}"
            [(ngModel)]="model.username" #username="ngModel" name="username" placeholder="User" required>
            <div *ngIf="f.submitted && !username.valid" class="help-block text" >Champs Obligatoire</div>
          </div>
            <div class="form-group titre">
              <input type="password"
              class="form-control text"
              [ngClass] = "{ 'forminput-invalid':f.submitted &&
            (!model.password ||model.password?.length == 0
            ||!password.valid )}"
            [(ngModel)]="model.password"
              #password="ngModel" required name="password"  placeholder="Mot de passe">
              <div *ngIf="f.submitted && !password.valid" class="help-block" >Champs Obligatoire</div>
          </div>
          <div class="text-center">
               <button  type="submit" class="btn btn-indigo titre">Se connecter</button><br/><br/>
               <a [routerLink]="['/loginResset']" >
                <button class="btn btn-info titre">Mot de passe oublié ?</button></a>
          </div>

      </form>
    </div>
  </div>
